export type InspectionData = {
    creationKey?: string;
    useYearMakeModel?: string;
    year?: string;
    make?: string;
    model?: string;
    description?: string;
    category_ID?: string;
    family_ID?: string;
    serialNumber?: string;
    assetNumber?: string;
    stockNumber?: string;
    unitOfMeasure_ID?: string;
    type_ID?: string;
    length?: string;
    quantity?: string;
};

export enum WorkOrderStatus {
    InProgress = "In Progress",
    Scheduled = "Scheduled",
    Completed = "Complete"
}

export enum PointType {
    Year = 1,
    Make = 2,
    Model = 3,
    StockNumber = 10,
    Description = 11,
}
